/* ============
 * Vue Router
 * ============
 *
 * The official Router for Vue.js. It deeply integrates with Vue.js core
 * to make building Single Page Applications with Vue.js a breeze.
 *
 * http://router.vuejs.org/en/index.html
 */

import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from '@routes';
import beforeEach from '@/router/beforeEach';
import scrollBehavior from '@/router/scrollBehavior';

Vue.use(VueRouter);

export const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior,
});

router.beforeEach(beforeEach);
Vue.router = router;

export default {
  router,
};
